/**
 * 매출 invoice 조회 폼 데이터
 * 배송운임, 사용내역서 조회 폼 데이터 공통
 */
export class FormDataGetInvoice {
    /** 허브 아이디 */
    selectedHubId = '';
    /** 상점 아이디 */
    seletedStoreId = 'ALL';
    /** 기간 */
    date = [];
    /** 자료검증 타입 */
    dataCheckType = 'ALL';
    /** 선택한 배송운임 아이디 */
    selectedDeliveryChargeId = '';
    constructor(data) {
        if (!data) {
            return;
        }
        Object.assign(this, data);
    }
}
